import defaultHtml from './default.html'

export const templateMap = Object.freeze({
  default: defaultHtml
});
